module.exports = "<p>res-menu works!</p>\n"